import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-large",
  "use": "icon-play-large-usage",
  "viewBox": "0 0 118 118",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 118 118\" id=\"icon-play-large\"><path d=\"M26.497 6.137l-.774-.506v106.757l.78-.53L105.17 58.46l.621-.421-.628-.41L26.497 6.136z\" fill=\"#fff\" stroke=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol